module.exports = __webpack_public_path__ + "img/Groupe 73.070f926e.svg";